import { Injectable } from '@angular/core';

@Injectable()
export class AtxRouterTabsService {
    public getPathname(count) {
        const splitPathname = location.pathname.split('/');

        console.log(splitPathname);

        return `/${ splitPathname.slice(1, -(splitPathname.length - count)).join('/') }/` ;
    }
}
